import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import DataTable from "../../components/Table/DataTable.jsx";
import DataTablePagination from "../../components/Table/DataTablePagination.jsx";
import { getAllUserRolesService } from "../../services/ticketsServices.js";
import {
  changeRoleToAdmin,
  deleteAdminService,
  getAllAdminsService,
  getAllCustomersService,
} from "../../services/usersServices.js";
import Confirm from "../../utils/Confirm.js";
import Actions from "./additionFields/Actions.jsx";
import EmailAndPhone from "./additionFields/EmailAndPhone.jsx";
import Role from "./additionFields/Role.jsx";
import Alert from "../../utils/Alert.js";

const Users = () => {
  const [admins, setAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdminMode, setIsAdminMode] = useState(false);
  const [userRoles, setUserRoles] = useState([]);

  const navigate = useNavigate();

  const { userRole } = localStorage.getItem("cncToken")
    ? JSON.parse(localStorage.getItem("cncToken"))
    : navigate("/auth/login");

  const customersCols = [
    {
      field: "id",
      text: "#",
    },
    {
      field: "name",
      text: "نام",
    },
    {
      field: "family",
      text: "نام خانوادگی",
    },
    {
      field: null,
      text: "ایمیل / شماره تلفن",
      element: (rowData) => <EmailAndPhone rowData={rowData} />,
    },
    {
      field: null,
      text: "آدرس",
      element: (rowData) => {
          return (
              <Button variant="contained" color="success"
                  onClick={() => navigate("/users/address", {
                      state: rowData.user_address
                  })}
              >
                  اطلاعات نشانی
              </Button>
        )
      }
    },
    {
      field: null,
      text: "شرکت",
      element: (rowData) => {
          return (
              <Button variant="contained" color="success"
                  onClick={() => navigate("/users/company", {
                      state: rowData.user_company
                  })}
              >
                  اطلاعات شرکت
              </Button>
        )
      }
    },
    {
      field: null,
      text: "عملیات‌ها",
      element: (rowData) => (
        <Actions
          rowData={rowData}
          handleDeleteAdmin={handleDeleteAdmin}
          handleChangeRoleToAdmin={handleChangeRoleToAdmin}
          isAdminMode={isAdminMode}
          userRole={userRole}
        />
      ),
    },
  ];

  const adminsCols = [
    {
      field: "id",
      text: "#",
    },
    {
      field: "name",
      text: "نام",
    },
    {
      field: "family",
      text: "نام خانوادگی",
    },
    {
      field: null,
      text: "ایمیل / شماره تلفن",
      element: (rowData) => <EmailAndPhone rowData={rowData} />,
    },
    {
      field: null,
      text: "آدرس",
      element: (rowData) => {
          return (
              <Button variant="contained" color="success"
                  onClick={() => navigate("/users/address", {
                      state: rowData.user_address
                  })}
              >
                  اطلاعات نشانی
              </Button>
        )
      }
    },
    {
      field: null,
      text: "شرکت",
      element: (rowData) => {
          return (
              <Button variant="contained" color="success"
                  onClick={() => navigate("/users/company", {
                      state: rowData.user_company
                  })}
              >
                  اطلاعات شرکت
              </Button>
        )
      }
    },
    {
      field: null,
      text: "نقش",
      element: (rowData) => <Role rowData={rowData} userRoles={userRoles} />,
    },
    {
      field: null,
      text: "عملیات‌ها",
      element: (rowData) => (
        <Actions
          rowData={rowData}
          handleDeleteAdmin={handleDeleteAdmin}
          isAdminMode={isAdminMode}
          userRole={userRole}
        />
      ),
    },
  ];

  const handleGetAllUsers = async () => {
    setIsLoading(true);
    try {
      if (userRole.id === 1 || userRole.id === 3) {
        const adminsResponse = await getAllAdminsService();
        if (adminsResponse.status === 200) {
          setAdmins(adminsResponse.data);
        }
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetAllUserRoles = async () => {
    try {
      const response = await getAllUserRolesService();
      if (response.status === 200) {
        let roles = response.data.map((r) => {
          return {
            text: r.name,
            value: r.id,
          };
        });
        // remove "customer" role.
        roles = roles.filter((r) => r.value !== 5);
        setUserRoles(roles);
      }
    } catch (error) {}
  };

  const handleDeleteAdmin = async (adminData) => {
    const result = await Confirm(
      "تایید عملیات",
      `آیا از حذف ادمین "${adminData.name} ${adminData.family}" مطمئن هستید؟`,
      "info",
      true,
      "لغو",
      "بله"
    );
    if (result) {
      try {
        const response = await deleteAdminService(adminData.id);
        if (response.status === 204) {
          setAdmins((prevAdmins) =>
            prevAdmins.filter((a) => a.id !== adminData.id)
          );
        }
      } catch (error) {}
    }
  };

  const handleChangeRoleToAdmin = async (id) => {
    try {
      const response = await changeRoleToAdmin(id);
      if (response.status === 200) {
        window.location.reload();
      }
    }catch (error) {
      Alert("خطا!", "در تغییر نقش کاربر به ادمین مشکلی پیش آمده", "error");
    }
  }

  const searchHandler = (ev, tableData, setSearchChar, setInitData) => {
    const char = ev.target.value;
    setSearchChar(char);
    const data = tableData.filter((d) => {
      return (
        d["email"]
          .toString()
          .toLowerCase()
          .includes(char.trim().toLowerCase()) ||
        d["phone_number"]
          .toString()
          .toLowerCase()
          .includes(char.trim().toLowerCase())
      );
    });
    setInitData(data);
  };

  useEffect(() => {
    handleGetAllUserRoles();
    handleGetAllUsers();
  }, []);

  return (
    <>
      {isAdminMode ? (
        <DataTable
          tableCols={
            userRole.id === 1
              ? adminsCols
              : adminsCols.slice(0, adminsCols.length - 1)
          }
          tableData={admins}
          itemsCount={10}
          title={"ادمین‌ها"}
          searchHandler={searchHandler}
          searchTitle="ایمیل یا شماره"
          isLoading={isLoading}
        >
          {(userRole.id === 1 || userRole.id === 3) && (
            <Button
              variant="contained"
              color="success"
              sx={{
                borderRadius: "10px",
              }}
              onClick={() => setIsAdminMode((prevValue) => !prevValue)}
            >
              {isAdminMode ? "نمایش مشتریان" : "نمایش ادمین‌ها"}
            </Button>
          )}

          {/* {isAdminMode && userRole.id === 1 && (
            <Link
              to="/users/add-user"
              className="bg-primary px-3 py-1 rounded-lg text-white"
            >
              افزودن ادمین
            </Link>
          )} */}
          <Outlet
            context={{
              setAdmins,
              isAdminMode,
              userRoles,
            }}
          />
        </DataTable>
      ) : (
        <DataTablePagination
          tableCols={customersCols}
          title="مشتريان"
          APIFunction={getAllCustomersService}
          dataField="customers"
          hasOutlet={true}
          outletData={{
            isAdminMode,
            userRoles,
          }}
        >
          {(userRole.id === 1 || userRole.id === 3) && (
            <Button
              variant="contained"
              color="success"
              sx={{
                borderRadius: "10px",
                mb: "0.5rem",
              }}
              onClick={() => setIsAdminMode((prevValue) => !prevValue)}
            >
              {isAdminMode ? "نمایش مشتریان" : "نمایش ادمین‌ها"}
            </Button>
          )}
        </DataTablePagination>
      )}
    </>
  );
};

export default Users;
